import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, VStack, Spinner } from '@chakra-ui/react';
import { useAuth } from '../AuthContext';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bg="#0a0a0a"
      >
        <VStack gap="4" align="center">
          <Spinner size="lg" color="cyan.400" />
        </VStack>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
